import { SimpleNewsOptions, SimpleNewsQuery, SimpleNewsQueryAndOptions } from '@benzinga/internal-news-manager';
import { formatTickerForNews } from '@benzinga/utils';

export const formatToSimpleNewsQueryParams = (
  queryParams: SimpleNewsQueryAndOptions,
): { options: SimpleNewsOptions; query: SimpleNewsQuery } => {
  if (!queryParams) return { options: {}, query: {} };
  const {
    after,
    allOriginalArticles,
    author,
    before,
    channelAndTagQueryOperator,
    channels,
    displayOutput,
    excludeAutomated,
    excludeContentTypes,
    excludeContributed,
    excludeNewsdesk,
    excludeSponsored,
    headlines,
    last,
    limit,
    offset,
    primaryChannel,
    primaryTicker,
    search,
    sortOrderCreated,
    tags,
    tickers,
    title,
    type,
    userId,
  } = queryParams;

  const typeParam: string[] | undefined = typeof type === 'string' ? type.split(',') : type || undefined;

  const options: SimpleNewsOptions = {
    after,
    allOriginalArticles,
    before,
    displayOutput,
    excludeAutomated,
    excludeContentTypes,
    excludeContributed,
    excludeNewsdesk,
    excludeSponsored,
    headlines: (headlines as string) === 'true' ? true : (headlines as string) === 'false' ? false : headlines,
    last,
    limit: limit ? Number(limit) : undefined,
    offset: offset ? Number(offset) : undefined,
    sortOrderCreated,
    type: typeParam,
  };

  const arrayOfTickers: string[] = typeof tickers === 'string' ? tickers.split(',') : tickers || [];
  const formattedSymbols = tickers ? formatSymbols(arrayOfTickers) : undefined;

  const query: SimpleNewsQuery = {
    author,
    channelAndTagQueryOperator,
    channels,
    primaryChannel,
    primaryTicker: primaryTicker
      ? (typeof primaryTicker === 'string' ? primaryTicker.split(',') : primaryTicker)
          .map(ticker => formatTickerForNews(ticker.trim()))
          .filter(Boolean)
      : undefined,
    search,
    tags,
    tickers: formattedSymbols,
    title,
    userId,
  };

  const result = {
    options,
    query,
  };

  return result;
};

export const formatSymbols = (symbols: string | string[]): string | string[] => {
  if (typeof symbols === 'string') {
    return formatTickerForNews(symbols);
  }
  return symbols.map(symbol => formatTickerForNews(symbol));
};
